import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { MainFeed } from '../models/feed.model';
import { MainFeedService } from '../services/api/main-feed.service';
import { tap } from 'rxjs';
import { FeedSourceService } from '../services/api/feed-source.service';

export const mainFeedResolver: ResolveFn<MainFeed> = route => {
    const mainFeedService = inject(MainFeedService);
    const feedSourceService = inject(FeedSourceService);
    return mainFeedService.getMainFeedById(route.params['id']).pipe(
        tap(mainFeed => {
            feedSourceService.setFeedSourceUrl(mainFeed.sourceUrl);
            feedSourceService.setPreviewSourceId(mainFeed.previewSourceId);
            feedSourceService.setRootArrayPath(mainFeed.rootArrayPath);
        })
    );
};
